import React from "react";
import { IoMdArrowBack } from 'react-icons/io';

export function Footer() {
    return (
        <div className={'text-center w-full p-3'}>
            <a
                className={'justify-center block  flex'}
                href={'https://www.xplanung24.de'}
                target={'_blank'}
                rel='noreferrer'>
                <IoMdArrowBack className={'mr-2 mt-1'} /> Zurück
            </a>
        </div>
    );
}